<template>
  <div class="receiving-address">
    <div class="box teal">
      <div class="van-address-list">
        <div class="van-address-item" v-for="(item, index) in list" :key="index">
          <div class="van-cell van-cell--borderless">
            <div class="van-cell__value van-cell__value--alone van-address-item__value">
              <div class="van-address-item__name">{{item.consignee}} {{item.consigneePhone}}<span class="van-tag van-address-item__tag" v-if="item.isPreferred">默认</span></div>
              <div class="van-address-item__address">{{item.address}}</div>
            </div>
            <i class="van-badge__wrapper van-icon van-icon-edit van-address-item__edit" @click="onEdit(item)"></i>
            <i class="van-badge__wrapper van-icon van-icon-delete-o" @click="onDelete(item)"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="van-address-list__bottom" @click="onAdd">
      <button class="van-button van-button--block van-address-list__add">
        <div class="van-button__content">
          <i class="van-icon van-icon-plus"/>
          <span class="van-button__text">新增地址</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import {defineComponent, ref, onMounted} from 'vue';
import {Dialog, Toast} from 'vant';
import {useRouter} from "vue-router";
import {getConsignees} from '../api/users';
import {deleteConsignee} from '../api/consignees';
import {isNotEmpty} from '../utils/util';

export default defineComponent({
  name: 'ReceivingAddress',
  setup() {
      const router = useRouter();
      const list = ref([]);
      // 获取常用收货地址
      const onConsignees = () => {
          getConsignees()
              .then(data => {
                  if(isNotEmpty(data)){
                      list.value = data;
                      list.value.forEach(item => {
                          if(item.consigneeAddress){
                              const addressJson = JSON.parse(item.consigneeAddress);
                              Object.assign(item, {
                                  address: addressJson.province + addressJson.city + addressJson.area + addressJson.detail,
                              })
                          }
                      })
                  }else {
                      list.value = [];
                  }
              })
              .catch((error) => {
                  console.error(error);
              });
      };
      const onAdd = () => {
          router.push({path: '/receivingAddressEdit'});
      };
      const onEdit = (item) => {
          router.push({path: '/receivingAddressEdit', query: {id: item.id}});
      };
      const onDelete = (item) => {
          Dialog.confirm({
              title: '删除收货地址',
              message: '确认删除此收货地址',
          })
              .then(() => {
                  deleteConsignee(item.id)
                      .then(data => {
                          if(data === null){
                              onConsignees();
                              Toast({message: '删除成功'});
                          }
                      })
                      .catch((error) => {
                          console.error(error);
                      });
              })
              .catch(() => {
              });
      };
      onMounted(() => {
          onConsignees();
      });
    return {
        onConsignees,
        onDelete,
        list,
        onAdd,
        onEdit,
    };
  },
});
</script>

<style scoped lang="less">
@import "../assets/css/box.less";
@import "../assets/css/address.less";
</style>
